  <span class="input-group-text"
        [pTooltip]="popoverText" tooltipPosition="top"
        [escape]="!renderHtml"
        [ngClass]="isDisabled ? '' : isRequired ? 'required-input-guide' : 'optional-input-guide'"
        [tooltipStyleClass]="isDisabled ? 'eca-tooltip-disabled' : isRequired ? 'eca-tooltip-required' : 'eca-tooltip-optional'">
    <fa-icon [icon]="['far', icon]"> </fa-icon>
  </span>
  <label *ngIf="label" [for]="controlId"><strong>{{label}}</strong></label>
